import { axiosGetAuthorize, axiosPostAuthorize } from '../AxiosRequests';
import { AddLeadershipPositions, GetLeadershipPositionsList, GetLeadershipPositionsById, DeleteLeadershipPositions, 
    UpdateLeadershipPositions, GetLeadershipChapters, GetLeadershipCommittee,AddCouncilDetails,GetCouncilDetails,GetCouncilDetailsById,DeleteCouncilDetails,
    UpdateCouncilDetails , GetAllSecretariatDetailsList,GetSecretariatDetailsById, AddSecretariatDetails, 
    UpdateSecretariatDetails, DeleteSecretariatDetails,} from '../ApiEndPoints'

export default class LeadershipPositionsServices {
    async addCouncilDetails(request) {
        return axiosPostAuthorize(AddCouncilDetails, request)
    }

    async getCouncilDetails(request) {
        return axiosPostAuthorize(GetCouncilDetails, request)
    }

    async getCouncilDetailsById(request) {
        return axiosGetAuthorize(GetCouncilDetailsById, request)
    }

    async deleteCouncilDetails(request) {
        return axiosPostAuthorize(DeleteCouncilDetails, request)
    }

    async updateCouncilDetails(request) {
        return axiosPostAuthorize(UpdateCouncilDetails, request)
    }

    async addLeadershipPositions(request) {
        return axiosPostAuthorize(AddLeadershipPositions, request)
    }

    async getLeadershipPositionsList(request) {
        return axiosPostAuthorize(GetLeadershipPositionsList, request)
    }

    async getLeadershipPositionsById(request) {
        return axiosGetAuthorize(GetLeadershipPositionsById, request)
    }

    async deleteLeadershipPositions(request) {
        return axiosPostAuthorize(DeleteLeadershipPositions, request)
    }

    async updateLeadershipPositions(request) {
        return axiosPostAuthorize(UpdateLeadershipPositions, request)
    }
    async getLeadershipChapters() {
        return axiosGetAuthorize(GetLeadershipChapters);
    }
    async getLeadershipCommittee() {
        return axiosGetAuthorize(GetLeadershipCommittee);
    }
}